function checkedToYes () {
    return function (input) {
        if (input === "checked") return "Yes";
        else if (input === "unchecked") return "No";
        else return "";
    };
}

angular.module('sentinel').filter('checkedToYes', checkedToYes);